export default "__VITE_ASSET__CJiDJw5E__"